/* Bulk product template — one source of truth for the selected volume,
   plus the gallery, the FAQ accordion, the sticky bar and the request form.
   Sections are siblings (OS 2.0 JSON template), so the document is the root. */
(function () {
  var hero = document.querySelector('[data-bulk-hero]');
  if (!hero) return;

  /* ---- volume: hero picker, tier cards, form select, every label ---- */
  var state = { volume: hero.dataset.bulkDefaultVolume || '' };

  function setVolume(value) {
    if (!value) return;
    state.volume = value;
    document.querySelectorAll('[data-bulk-volume]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.bulkVolume === value));
    });
    document.querySelectorAll('[data-bulk-tier]').forEach(function (c) {
      c.dataset.selected = String(c.dataset.bulkTier === value);
    });
    document.querySelectorAll('[data-bulk-volume-label]').forEach(function (el) { el.textContent = value; });
    var select = document.querySelector('[data-bulk-volume-select]');
    if (select && select.value !== value) select.value = value;
  }

  /* CTA intent → form checkboxes. "documents" ticks COA + TDS. */
  var NEEDS = { quote: ['quote'], documents: ['coa', 'tds'], sample: ['sample'] };

  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-bulk-volume]');
    if (pick) { setVolume(pick.dataset.bulkVolume); return; }

    var wa = e.target.closest('[data-bulk-wa]');
    if (wa) {
      e.preventDefault();
      var number = wa.dataset.bulkWa.split('').reverse().join('');
      window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(wa.dataset.bulkWaText), '_blank', 'noopener');
      return;
    }

    var cta = e.target.closest('[data-bulk-request]');
    if (!cta) return;
    if (cta.dataset.bulkTier) setVolume(cta.dataset.bulkTier);
    var keys = NEEDS[cta.dataset.bulkRequest] || [];
    document.querySelectorAll('[data-bulk-need]').forEach(function (input) {
      if (keys.indexOf(input.dataset.bulkNeed) !== -1) input.checked = true;
    });
  });

  var select = document.querySelector('[data-bulk-volume-select]');
  if (select) select.addEventListener('change', function () { setVolume(select.value); });

  setVolume(state.volume);

  /* ---- gallery ---- */
  var main = hero.querySelector('[data-bulk-gallery-main]');
  var count = hero.querySelector('[data-bulk-gallery-count]');
  var thumbs = hero.querySelectorAll('[data-bulk-thumb]');
  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      if (!main) return;
      main.src = thumb.dataset.bulkThumb;
      if (thumb.dataset.bulkThumbSrcset) main.srcset = thumb.dataset.bulkThumbSrcset;
      main.alt = thumb.dataset.bulkThumbAlt || '';
      thumbs.forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
      if (count) count.textContent = (i + 1) + ' / ' + thumbs.length;
    });
  });

  /* ---- faq ---- */
  document.querySelectorAll('[data-bulk-faq-q]').forEach(function (q) {
    q.addEventListener('click', function () {
      var open = q.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(q.getAttribute('aria-controls'));
      q.setAttribute('aria-expanded', String(!open));
      if (panel) panel.hidden = open;
    });
  });

  /* ---- sticky request bar (mobile): shows once the hero CTA scrolled above the header, hides on the form ---- */
  var bar = document.querySelector('[data-bulk-stickybar]');
  var anchor = hero.querySelector('[data-bulk-hero-cta]');
  var form = document.querySelector('[data-bulk-form]');
  if (bar && anchor) {
    var ticking = false;
    function paint() {
      ticking = false;
      var heroGone = anchor.getBoundingClientRect().bottom < 80;
      var formShown = false;
      if (form) {
        var r = form.getBoundingClientRect();
        formShown = r.top < window.innerHeight && r.bottom > 0;
      }
      bar.dataset.visible = String(heroGone && !formShown);
    }
    /* ponytail: scroll + rAF instead of IntersectionObserver, which misses anchor jumps that skip the element entirely */
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  }

  /* ---- form: at least one need, honeypot, time trap, success event ---- */
  if (form) {
    var opened = Date.now();
    form.addEventListener('submit', function (e) {
      var trap = form.querySelector('[data-bulk-trap]');
      if ((trap && trap.value) || Date.now() - opened < 2500) { e.preventDefault(); return; }
      var needs = form.querySelectorAll('[data-bulk-need]');
      var any = Array.prototype.some.call(needs, function (n) { return n.checked; });
      if (needs.length && !any) {
        e.preventDefault();
        form.setAttribute('data-bulk-invalid', '');
        needs[0].focus();
        return;
      }
      form.removeAttribute('data-bulk-invalid');
      var items = Array.prototype.filter.call(needs, function (n) { return n.checked; })
        .map(function (n) { return n.value; }).join(', ');
      /* Shopify re-renders the page on success without the posted fields; keep them for the event. */
      try { sessionStorage.setItem('bulk_request', JSON.stringify({ volume: state.volume, items: items })); } catch (err) {}
    });
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-bulk-need]')) form.removeAttribute('data-bulk-invalid');
    });

    /* Success: Shopify re-renders the page with the success block. Fire one event for GA4 / Meta. */
    var success = form.querySelector('[data-bulk-success]');
    if (success) {
      var detail = { volume: '', items: '' };
      try {
        detail = JSON.parse(sessionStorage.getItem('bulk_request') || '{}');
        sessionStorage.removeItem('bulk_request');
      } catch (err) {}
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'bulk_request_submitted', bulk_volume: detail.volume, bulk_items: detail.items });
      document.dispatchEvent(new CustomEvent('bulk:request_submitted', { detail: detail }));
      success.scrollIntoView({ block: 'center' });
    }
  }
})();
